import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './HintBlock.css';

interface HintBlockProps {
    icon?: JSX.Element;
    children: React.ReactNode;
    cls?: string;
}

export class HintBlock extends React.Component<HintBlockProps> {
    public static defaultProps = {
        icon: <Shape2 icon={Shape2Icon.info} width={16} height={16} tone={Shape2Tone.yellow} />
    };

    render() {
        return (
            <div className={classNames(Bem.cls('hint-block'), this.props.cls)}>
                <div className={Bem.cls('hint-block', 'icon')}>{this.props.icon}</div>
                <div className={Bem.cls('hint-block', 'content')}>{this.props.children}</div>
            </div>
        );
    }
}
